import { Component, Input } from '@angular/core';

/**
 * The headset mark used by the Customer Support tool in the topbar.
 *
 * Everything that means "support" reuses THIS glyph rather than Material's
 * `support_agent`, so the support session, the impersonation chip and the
 * support tool itself read as one thing.
 *
 * Inherits `currentColor` and takes its size from the host's font-size (1em),
 * so it drops into a chip, a heading or an icon button without extra rules;
 * pass `size` for a fixed pixel box.
 */
@Component({
  selector: 'app-support-icon',
  standalone: true,
  template: `
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.5"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"
         [style.width]="dimension" [style.height]="dimension">
      <path d="M8 28v-8a16 16 0 0 1 32 0v8"/>
      <rect x="4" y="26" width="7" height="12" rx="3.5"/>
      <rect x="37" y="26" width="7" height="12" rx="3.5"/>
      <path d="M37 38c0 4-4 6-8 6h-2"/>
      <circle cx="25" cy="44" r="2.5"/>
    </svg>
  `,
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: 0;
    }
  `],
})
export class SupportIconComponent {
  /** Pixel size; omit to scale with the surrounding text. */
  @Input() size?: number;

  get dimension(): string {
    return this.size ? `${this.size}px` : '1em';
  }
}
